import React from 'react';
import { whyUs } from '../mock';
import { Ruler } from 'lucide-react';
import useReveal from '../hooks/useReveal';

function WhyCard({ w, i }) {
  const [ref, inView] = useReveal(0.15);
  return (
    <div ref={ref} className={`lift-card corners reveal delay-${(i % 5) + 1} ${inView ? 'in-view' : ''}`}
      style={{ padding: 24, background: 'rgba(15, 31, 34, 0.5)', border: '1px solid var(--line)' }}
      onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-6px)'; e.currentTarget.style.background = 'rgba(42, 154, 160, 0.06)'; }}
      onMouseLeave={(e) => { e.currentTarget.style.transform = ''; e.currentTarget.style.background = 'rgba(15, 31, 34, 0.5)'; }}
    >
      <div className="font-mono" style={{ color: i % 2 === 0 ? 'var(--teal-light)' : 'var(--orange)', fontSize: 11, letterSpacing: '0.22em', marginBottom: 14 }}>{w.num}</div>
      <h3 className="font-display" style={{ color: 'var(--paper)', fontSize: 22, marginBottom: 10, letterSpacing: '-0.01em' }}>{w.title}</h3>
      <p style={{ color: 'var(--smoke)', fontSize: 13, lineHeight: 1.6 }}>{w.desc}</p>
    </div>
  );
}

export default function WhyUs() {
  const [ref, inView] = useReveal(0.1);
  return (
    <section id="why" ref={ref} className="section" style={{ position: 'relative' }}>
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-8 items-end" style={{ marginBottom: 60 }}>
          <div className={`lg:col-span-7 reveal ${inView ? 'in-view' : ''}`}>
            <div className="eyebrow" style={{ marginBottom: 24 }}>§ 04 · Our Advantage</div>
            <h2 className="section-title">Why <em>Vistora</em>.</h2>
          </div>
          <div className={`lg:col-span-5 reveal delay-2 ${inView ? 'in-view' : ''}`}>
            <p style={{ color: 'var(--smoke)', fontSize: 15, lineHeight: 1.7 }}>
              Six reasons drafted like a blueprint — senior leadership, ruthless quality control, and a nationwide install network built to scale corporate rollouts.
            </p>
          </div>
        </div>

        <div className="blueprint" style={{ padding: 40, position: 'relative' }}>
          <div className="flex items-center justify-between" style={{ borderBottom: '1px dashed var(--teal-2)', paddingBottom: 14, marginBottom: 30 }}>
            <div className="flex items-center gap-3">
              <Ruler size={18} color="var(--teal-light)" />
              <span className="font-mono" style={{ color: 'var(--teal-light)', fontSize: 11, letterSpacing: '0.22em' }}>DRWG-A / ADVANTAGE.SPEC</span>
            </div>
            <div className="font-mono" style={{ color: 'var(--muted)', fontSize: 10, letterSpacing: '0.2em' }}>SCALE 1:1 · REV. 2024</div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {whyUs.map((w, i) => <WhyCard key={w.title} w={w} i={i} />)}
          </div>

          <div style={{ borderTop: '1px dashed var(--teal-2)', marginTop: 40, paddingTop: 30, textAlign: 'center' }}>
            <p className="font-serif-i" style={{ color: 'var(--paper)', fontSize: 22, lineHeight: 1.5, maxWidth: 720, margin: '0 auto' }}>
              &ldquo;Your brand will always look its best — every print, every sign, every installation.&rdquo;
            </p>
            <div className="font-mono" style={{ color: 'var(--orange)', fontSize: 10, letterSpacing: '0.28em', marginTop: 16, textTransform: 'uppercase' }}>
              — Our Promise to You
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
